/* ============================================================
   Shared helpers for the Deal Management module.
   Ported from the prototype's components.js pure helpers.
   ============================================================ */

import { STEPS } from './data/config';

/* Base path the module is mounted at (see AnimatedRoutes). */
export const BASE = '/deal-management';

/* Traffic-light class for a 0–100 score (70+ green, 50–69 amber, <50 red). */
export function scoreClass(score) {
	if (score == null) return '';
	return score >= 70 ? 'score--green' : score >= 50 ? 'score--amber' : 'score--red';
}

/* Two-letter initials from a deal/company name. */
export function initialsOf(name) {
	return name.split(' ').map(w => w[0]).slice(0, 2).join('');
}

/* Which workspace step a deal opens at, from its pipeline stage. */
export function defaultStep(deal) {
	const map = { new: 'intake', analysis: 'analysis', triage: 'triage', diligence: 'diligence', ic: 'decision' };
	return map[deal.stage] || 'intake';
}

/* Map a traffic-light level to its token colour (finding dots, bars). */
export function levelColor(level) {
	return level === 'green' ? 'var(--dlg-green)'
		: level === 'amber' ? 'var(--dlg-amber)'
		: level === 'red' ? 'var(--dlg-red)'
		: 'var(--dlg-blue)';
}

/* Step index (1-based) + name for a given step id. */
export function stepMeta(stepId) {
	const idx = STEPS.findIndex(s => s.id === stepId);
	return { idx, num: idx + 1, name: STEPS[idx] ? STEPS[idx].name : '' };
}
